import { Tables } from "@/integrations/supabase/types";
import { cn } from "@/lib/utils";
import { formatPrice } from "@/utils/formatPrice";
import { useMemo } from "react";

interface Props {
  binder: Tables<"binders"> & { card_count: string; total_sum: string };
  active: boolean;
  onClick: () => void;
  disabled: boolean;
}

export function AddCardToBinderBindersInputItem({
  binder,
  active,
  onClick,
  disabled,
}: Props) {
  const name = binder.name;
  const count = Number(binder.card_count);
  const sum = Number(binder.total_sum);
  const formattedSum = useMemo(() => {
    return sum ? formatPrice(sum) : "";
  }, [sum]);

  return (
    <button
      className={cn(
        "whitespace-nowrap p-4 border border-input rounded-lg grid text-left",
        {
          "border-[#00c2ff]": active,
          "bg-[#00c2ff1a]": active,
          "opacity-90": disabled,
          "cursor-pointer": !disabled,
        },
      )}
      onClick={onClick}
      disabled={disabled}
    >
      <p className="">{name}</p>
      <p className="flex items-center gap-2">
        <span className="text-[#ff1493]">{count} cards </span>
        <span className="text-[#34d399]">{formattedSum}</span>
      </p>
    </button>
  );
}
